import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "operation-bar"
};
const _hoisted_2 = {
  class: "table-wrap"
};
const _hoisted_3 = {
  class: "header-filter"
};
const _hoisted_4 = {
  class: "header-title"
};
const _hoisted_5 = {
  class: "header-filter"
};
const _hoisted_6 = {
  class: "header-filter"
};
const _hoisted_7 = {
  class: "header-filter"
};
const _hoisted_8 = {
  class: "header-filter"
};
const _hoisted_9 = {
  class: "header-filter"
};
const _hoisted_10 = {
  class: "header-filter"
};
const _hoisted_11 = {
  class: "header-filter"
};
const _hoisted_12 = {
  key: 0,
  class: "cell-content"
};
const _hoisted_13 = ["onContextmenu"];
const _hoisted_14 = {
  key: 0,
  class: "editing-amount-cell"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "cell-content"
};
const _hoisted_17 = ["onContextmenu"];
const _hoisted_18 = {
  key: 0,
  class: "editing-amount-cell"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "cell-content"
};
const _hoisted_21 = {
  key: 0,
  class: "editing-amount-cell"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "contract-list-btn"
};
const _hoisted_24 = {
  class: "dialog-footer"
};
const _hoisted_25 = {
  key: 0,
  class: "empty-proof"
};
const _hoisted_26 = {
  class: "contract-list-btn"
};
const _hoisted_27 = {
  class: "dialog-footer"
};
const _hoisted_28 = {
  key: 0,
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_29 = {
  class: "month-proof-template-actions"
};
const _hoisted_30 = {
  class: "dialog-footer"
};
const _hoisted_31 = {
  class: "dialog-footer"
};
const _hoisted_32 = {
  class: "dialog-footer"
};
import { computed, ref, reactive, onMounted, watch, nextTick } from 'vue';
import { ElMessage } from "element-plus";
import dayjs from "dayjs";
import apis from "@/api";
import { InfoFilled } from '@element-plus/icons-vue';
import { accrueCommitAudit, addAccrueFiles, auditAccrueDetail, deleteAccrueFiles, exportAccrueExcel, exportAccrueFile, updateAccrueMonthProofTemplate, urgeAccrueDetail } from "@/api/modules/advert";
import MoreUpload from '@/components/MoreUpload.vue';
export default {
  __name: 'Detail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 0 // 0查看 1审核 2编辑
    },
    month: {
      type: String,
      default: ''
    },
    monthId: {
      type: String,
      default: ''
    },
    accrueProofTemplateUrls: {
      type: String,
      default: ''
    },
    userRole: {
      type: Object,
      default: () => ({
        areaCode: '-1',
        isAdmin: false,
        isSupplier: false,
        userId: ''
      })
    }
  },
  emits: ['update:visible', 'close'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const close = () => {
      emit('update:visible', false);
      emit('close');
    };

    // 计算标题：年月计提表-操作名
    const dialogTitle = computed(() => {
      if (!props.month) return props.title;
      const year = props.month.split('-')[0];
      const month = props.month.split('-')[1];
      return `${year}年${month}月计提表-${props.title}`;
    });

    // 表格数据
    const tableData = ref([]);
    const fullTableData = ref([]);
    const selectedRows = ref([]);
    const headerFilters = reactive({
      budgetCode: [],
      budgetName: [],
      projectType: [],
      contractCode: [],
      contractName: [],
      status: [],
      supplier: [],
      adProject: []
    });
    const getDistinctOptions = prop => {
      const values = fullTableData.value.map(item => item === null || item === void 0 ? void 0 : item[prop]).filter(value => value !== undefined && value !== null && String(value).trim() !== '');
      return [...new Set(values)].map(value => ({
        label: prop === 'status' ? getstatusText(value) : String(value),
        value
      }));
    };
    const filteredTableData = computed(() => {
      const fields = Object.keys(headerFilters);
      return fullTableData.value.filter(row => {
        return fields.every(field => {
          const selected = headerFilters[field];
          if (!selected || selected.length === 0) return true;
          const rowValue = row === null || row === void 0 ? void 0 : row[field];
          return selected.some(item => String(item) === String(rowValue));
        });
      });
    });

    // 表格高度
    const tableHeight = computed(() => {
      // 全屏对话框高度减去操作栏和对话框头部、底部边距
      return 'calc(100vh - 200px)';
    });

    // 当月发生金额列表
    const currentMonthAmountCategories = [{
      prop: 'currentMonthTotal',
      name: '合计'
    }, {
      prop: 'personalAmount',
      name: '个人市场业务'
    }, {
      prop: 'familyAmount',
      name: '家庭市场业务'
    }];

    // 部门列表（不包含合计，合计是计算出来的）
    const departments = [{
      prop: 'marketAmount',
      name: '市场经营部'
    }, {
      prop: 'legalAmount',
      name: '法律事务部'
    }, {
      prop: 'groupClientAmount',
      name: '集团客户部'
    }, {
      prop: 'unionAmount',
      name: '工会'
    }, {
      prop: 'partyOfficeAmount',
      name: '党委办公室（党群工作部）'
    }, {
      prop: 'generalOfficeAmount',
      name: '综合部'
    }, {
      prop: 'keyClientCenterAmount',
      name: '重要客户中心'
    }, {
      prop: 'hrAmount',
      name: '人力资源部'
    }, {
      prop: 'networkAmount',
      name: '网络部'
    }, {
      prop: 'disciplinaryOfficeAmount',
      name: '纪委办公室'
    }, {
      prop: 'inspectionOfficeAmount',
      name: '巡察工作办公室(党风廉政办公室)'
    }, {
      prop: 'itDepartmentAmount',
      name: '信息技术部'
    }, {
      prop: 'financeAmount',
      name: '财务部'
    }, {
      prop: 'procurementAmount',
      name: '采购部'
    }, {
      prop: 'branchCompanyAmount',
      name: '内审部'
    }];

    // 计算合计
    const calculateTotal = (row, propList, fieldName = 'currentAmount') => {
      let total = 0;
      propList.forEach(item => {
        if (item.prop !== 'currentMonthTotal') {
          // 排除合计本身
          const amountObj = getAmountObj(row, item.prop);
          if (amountObj) {
            const value = parseFloat(amountObj[fieldName] || 0);
            total += value;
          }
        }
      });
      return total.toFixed(2);
    };

    // 格式化金额
    const formatAmount = amount => {
      if (amount === null || amount === undefined || amount === '') return '0.00';
      return parseFloat(amount).toFixed(2);
    };

    // 加载数据
    const loading = ref(false);
    /** 与 ContractSelect 中 form.accrueProofTemplateUrls 一致：英文逗号分隔；仅由 Index 传入 */
    const monthProofTemplateUrls = ref('');
    const loadData = () => {
      if (!props.month) {
        ElMessage.warning('月份信息缺失');
        return;
      }
      loading.value = true;
      const params = {
        month: props.month,
        monthId: props.monthId || ''
        // areaCode: props.userRole?.areaCode || ''
      };
      apis.accrueDetailList(params).then(response => {
        if (response.success && Array.isArray(response.data)) {
          // 转换数据格式
          const formattedData = response.data.map(item => {
            // 格式化日期
            item.contractPeriod = item.startDate && item.endDate ? `${dayjs(item.startDate).format('YYYY-MM-DD')} 至 ${dayjs(item.endDate).format('YYYY-MM-DD')}` : '';
            // 格式化 amountMap 中的金额
            Object.keys(item.amountMap).forEach(key => {
              if (item.amountMap[key]) {
                item.amountMap[key].currentAmount = formatAmount(item.amountMap[key].currentAmount);
                item.amountMap[key].lastAmount = formatAmount(item.amountMap[key].lastAmount);
              }
            });
            return item;
          });
          fullTableData.value = formattedData;
          tableData.value = formattedData;
        } else {
          ElMessage.error(response.msg || '查询失败');
          tableData.value = [];
          fullTableData.value = [];
        }
      }).catch(error => {
        console.error('查询数据失败:', error);
        ElMessage.error('查询数据失败');
        tableData.value = [];
        fullTableData.value = [];
      }).finally(() => {
        loading.value = false;
      });
    };

    // 监听 visible 变化，重新加载数据
    watch(() => props.visible, newVal => {
      if (newVal) {
        monthProofTemplateUrls.value = props.accrueProofTemplateUrls || '';
        loadData();
      }
    });

    // 表格引用
    const tableRef = ref(null);

    // 初始化时加载数据
    onMounted(() => {
      if (props.visible) {
        monthProofTemplateUrls.value = props.accrueProofTemplateUrls || '';
        loadData();
      }
    });

    // 审核对话框
    const auditDialog = reactive({
      visible: false,
      isBatch: false,
      // 是否是批量审核
      auditResult: '',
      // 通过/不通过
      auditDesc: '',
      // 审核描述
      currentRow: null // 当前审核的行（单条审核时使用）
    });

    // 证明材料对话框
    const proofDialog = reactive({
      visible: false,
      currentRow: null,
      // 当前查看的合同行
      fileList: [] // 证明材料列表
    });

    // 上传证明材料对话框
    const uploadProofDialog = reactive({
      visible: false,
      currentRow: null // 当前上传的合同行
    });

    // 月度「计提证明材料模板」（与 ContractSelect 同源字段 accrueProofTemplateUrls）
    const proofTemplateMonthDialog = reactive({
      visible: false,
      fileList: [],
      uploadVisible: false
    });
    const parseMonthProofTemplateFileList = urlString => {
      if (!urlString) return [];
      return String(urlString).split(',').map(item => item.trim()).filter(Boolean).map((url, index) => {
        const segments = url.split('/');
        const rawName = segments[segments.length - 1] || `文件${index + 1}`;
        return {
          id: `month-template-${index}-${rawName}`,
          fileUrl: url,
          fileName: decodeURIComponent(rawName)
        };
      });
    };
    const syncMonthProofTemplateUrlsFromDialog = () => {
      monthProofTemplateUrls.value = proofTemplateMonthDialog.fileList.map(item => item.fileUrl).filter(Boolean).join(',');
    };
    const persistMonthAccrueProofTemplate = async urlsString => {
      apis.updateAccrueMonthProofTemplate({
        id: props.monthId,
        accrueProofTemplateUrls: urlsString
      }).then(res => {
        if (res.success) {
          ElMessage.success('保存成功');
        } else {
          ElMessage.error(res.msg);
        }
      });
      return Promise.resolve();
    };
    const openMonthProofTemplateDialog = () => {
      proofTemplateMonthDialog.fileList = parseMonthProofTemplateFileList(monthProofTemplateUrls.value);
      proofTemplateMonthDialog.visible = true;
    };

    // 供应商导入填写对话框
    const vendorImportDialog = reactive({
      visible: false,
      fileList: [],
      uploading: false
    });
    const exportTemp = () => {
      if (!props.monthId) {
        ElMessage.warning('月份标识缺失，无法导出');
        return;
      }
      apis.downloadAccrueVendorTemplate({
        monthId: props.monthId
      }).then(res => {
        if (res && typeof res === 'object' && !(res instanceof Blob) && !Array.isArray(res)) {
          if ('success' in res && res.success === false || res.code && typeof res.code === 'string' && res.code.startsWith('010')) {
            ElMessage.error(res.msg || '导出失败');
            return Promise.reject(new Error(res.msg || '导出失败'));
          }
        }
        const name = props.month ? `供应商填写模板_${props.month}.xlsx` : '供应商填写模板.xlsx';
        downloadFile(res, name);
        return Promise.resolve();
      }).catch(error => {
        if (error && typeof error === 'object' && error.msg) {
          ElMessage.error(error.msg);
        } else {
          ElMessage.error('导出失败');
        }
      });
    };
    const importTemp = () => {
      vendorImportDialog.visible = true;
      vendorImportDialog.fileList = [];
      vendorImportDialog.uploading = false;
    };
    const closeVendorImportDialog = () => {
      vendorImportDialog.visible = false;
      vendorImportDialog.fileList = [];
      vendorImportDialog.uploading = false;
    };
    const handleVendorImportFileChange = file => {
      vendorImportDialog.fileList = [file];
    };
    const handleVendorImportFileRemove = () => {
      vendorImportDialog.fileList = [];
    };
    const handleVendorImportConfirm = () => {
      if (!props.monthId) {
        ElMessage.warning('月份标识缺失，无法导入');
        return;
      }
      if (vendorImportDialog.fileList.length === 0) {
        ElMessage.warning('请选择文件');
        return;
      }
      vendorImportDialog.uploading = true;
      const formData = new FormData();
      formData.append('monthId', props.monthId);
      formData.append('file', vendorImportDialog.fileList[0].raw);
      apis.importAccrueVendorExcel(formData).then(res => {
        if (res.success) {
          ElMessage.success('导入成功');
          closeVendorImportDialog();
          loadData();
        } else {
          ElMessage.error(res.msg || '导入失败');
        }
      }).catch(error => {
        console.error('导入失败:', error);
        ElMessage.error('导入失败');
      }).finally(() => {
        vendorImportDialog.uploading = false;
      });
    };
    const closeMonthProofTemplateDialog = () => {
      proofTemplateMonthDialog.visible = false;
    };
    const handlePreviewMonthProofTemplate = row => {
      if (!(row !== null && row !== void 0 && row.fileUrl)) {
        ElMessage.warning('文件地址不存在');
        return;
      }
      apis.getFileEndPoint().then(res => {
        window.open(res.data + row.fileUrl);
      });
    };
    const handleDeleteMonthProofTemplate = row => {
      if (!props.userRole.isAdmin) {
        return;
      }
      proofTemplateMonthDialog.fileList = proofTemplateMonthDialog.fileList.filter(item => item.id !== row.id);
      syncMonthProofTemplateUrlsFromDialog();
      persistMonthAccrueProofTemplate(monthProofTemplateUrls.value);
    };
    const handleUploadMonthProofTemplateSuccess = files => {
      if (!props.userRole.isAdmin) {
        return;
      }
      if (!files || files.length === 0) {
        ElMessage.warning('请先上传文件');
        return;
      }
      const newFiles = files.map((file, index) => ({
        id: file.id || `month-template-up-${Date.now()}-${index}-${file.fileName || '文件'}`,
        fileName: file.fileName || `文件${index + 1}`,
        fileUrl: file.relativeUrl || file.fileUrl || ''
      })).filter(item => item.fileUrl);
      if (newFiles.length === 0) {
        ElMessage.error('上传返回文件地址为空');
        return;
      }
      proofTemplateMonthDialog.fileList.push(...newFiles);
      syncMonthProofTemplateUrlsFromDialog();
      proofTemplateMonthDialog.uploadVisible = false;
      persistMonthAccrueProofTemplate(monthProofTemplateUrls.value);
    };

    // 打开批量审核对话框
    const handleBatchAudit = () => {
      if (selectedRows.value.length === 0) {
        ElMessage.warning('请先选择要审核的合同');
        return;
      }
      // 检查选中的行是否都是待审核状态（状态2）
      const invalidRows = selectedRows.value.filter(row => row.status !== 2);
      if (invalidRows.length > 0) {
        ElMessage.warning('只能选择待审核状态的合同进行批量审核');
        return;
      }
      auditDialog.visible = true;
      auditDialog.isBatch = true;
      auditDialog.auditResult = '';
      auditDialog.auditDesc = '';
    };

    // 打开单条审核对话框
    const handleSingleAudit = row => {
      if (row.status !== 2) {
        ElMessage.warning('只能审核待审核状态的合同');
        return;
      }
      auditDialog.visible = true;
      auditDialog.isBatch = false;
      auditDialog.currentRow = row;
      auditDialog.auditResult = '';
      auditDialog.auditDesc = '';
    };

    // 提交审核
    const handleSubmitAudit = () => {
      if (!auditDialog.auditResult) {
        ElMessage.warning('请选择审核结果');
        return;
      }
      if (auditDialog.auditResult === 'reject' && !auditDialog.auditDesc.trim()) {
        ElMessage.warning('不通过时审核描述为必填项');
        return;
      }
      const formData = {
        ids: auditDialog.isBatch ? selectedRows.value.map(row => row.id) : [auditDialog.currentRow.id],
        auditDesc: auditDialog.auditDesc,
        status: auditDialog.auditResult
      };
      apis.auditAccrueDetail(formData).then(res => {
        if (res.success) {
          ElMessage.success('审核成功');
          auditDialog.visible = false;
          auditDialog.auditResult = '';
          auditDialog.auditDesc = '';
          auditDialog.currentRow = null;
          tableRef.value.clearSelection();
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(error => {
        console.error('审核提交失败:', error);
      }).finally(() => {
        loadData();
      });
    };

    // 下载文件函数
    const downloadFile = (data, fileName) => {
      if (!data) {
        ElMessage.error('下载数据为空');
        return;
      }

      // 检查是否为 JSON 错误响应对象
      if (typeof data === 'object' && !(data instanceof Blob) && !Array.isArray(data)) {
        // 检查是否是错误响应格式（有 code、success、msg 等字段）
        if ('code' in data || 'success' in data || 'msg' in data) {
          // 如果是错误响应，显示错误消息
          if (data.success === false || data.code && typeof data.code === 'string' && data.code.startsWith('010')) {
            const errorMsg = data.msg || '导出失败';
            ElMessage.error(errorMsg);
            return false;
          }
        }
      }

      // 处理 Blob 类型的数据（可能是 JSON 错误被包装成 Blob）
      if (data instanceof Blob) {
        // 检查 Blob 的大小，如果太小可能是 JSON 错误响应
        if (data.size < 1024) {
          // 小于 1KB 可能是错误消息
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const text = reader.result;
              const parsed = JSON.parse(text);
              // 检查是否是错误响应格式
              if (parsed && typeof parsed === 'object' && ('code' in parsed || 'success' in parsed || 'msg' in parsed)) {
                if (parsed.success === false || parsed.code && typeof parsed.code === 'string' && parsed.code.startsWith('010')) {
                  const errorMsg = parsed.msg || '导出失败';
                  ElMessage.error(errorMsg);
                  return;
                }
              }
              // 如果不是错误响应，继续下载
              performDownload(data, fileName);
            } catch (e) {
              // 不是 JSON，可能是正常的二进制数据，继续下载
              performDownload(data, fileName);
            }
          };
          reader.onerror = () => {
            // 读取失败，尝试直接下载
            performDownload(data, fileName);
          };
          reader.readAsText(data, 'utf-8');
          return;
        } else {
          // Blob 较大，直接下载
          performDownload(data, fileName);
          return;
        }
      }

      // 检查数据是否为字符串类型的 JSON
      if (typeof data === 'string') {
        try {
          const parsed = JSON.parse(data);
          // 如果解析后是错误响应格式
          if (parsed && typeof parsed === 'object' && ('code' in parsed || 'success' in parsed || 'msg' in parsed)) {
            if (parsed.success === false || parsed.code && typeof parsed.code === 'string' && parsed.code.startsWith('010')) {
              const errorMsg = parsed.msg || '导出失败';
              ElMessage.error(errorMsg);
              return false;
            }
          }
        } catch (e) {
          // 不是 JSON 字符串，继续处理为 blob
        }
      }

      // 执行下载
      try {
        const blob = data instanceof Blob ? data : new Blob([data]);
        performDownload(blob, fileName);
      } catch (error) {
        console.error('下载失败:', error);
        ElMessage.error('下载失败: ' + (error.message || '未知错误'));
      }
    };

    // 执行实际的下载操作
    const performDownload = (blob, fileName) => {
      try {
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // IE浏览器
          window.navigator.msSaveBlob(blob, fileName);
        } else {
          // 其他浏览器
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          // 延迟移除，确保下载开始
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
        }
      } catch (error) {
        console.error('下载失败:', error);
        ElMessage.error('下载失败: ' + (error.message || '未知错误'));
      }
    };
    const getExportPayload = (extra = {}) => {
      if (selectedRows.value.length === 0) {
        ElMessage.warning('请先勾选需要导出的明细');
        return null;
      }
      return {
        monthId: props.monthId,
        detailIds: selectedRows.value.map(row => row.id),
        ...extra
      };
    };

    // 导出详情
    const handleExportDetail = type => {
      const payload = getExportPayload({
        type
      });
      if (!payload) return Promise.resolve();
      return apis.exportAccrueExcel(payload).then(res => {
        // 先检查响应是否为错误对象（JSON 格式）
        if (res && typeof res === 'object' && !(res instanceof Blob) && !Array.isArray(res)) {
          // 检查是否有 success 字段且为 false，或者有 code 字段且以 '010' 开头
          if ('success' in res && res.success === false || res.code && typeof res.code === 'string' && res.code.startsWith('010')) {
            const errorMsg = res.msg || '导出失败';
            ElMessage.error(errorMsg);
            return Promise.reject(new Error(errorMsg));
          }
        }
        // 调用下载函数（内部会进一步检查 Blob 内容）
        downloadFile(res, type === 1 ? '广告宣传费计提表.xlsx' : '广告宣传费计提表.pdf');
        return Promise.resolve();
      }).catch(error => {
        // 如果错误对象包含 msg，显示具体的错误消息
        if (error && typeof error === 'object' && error.msg) {
          ElMessage.error(error.msg);
        } else {
          ElMessage.error('导出失败');
        }
        return Promise.reject(error);
      });
    };

    // 导出证明材料
    const handleExportProof = () => {
      const payload = getExportPayload();
      if (!payload) return Promise.resolve();
      return apis.exportAccrueFile(payload).then(res => {
        // 先检查响应是否为错误对象（JSON 格式）
        if (res && typeof res === 'object' && !(res instanceof Blob) && !Array.isArray(res)) {
          // 检查是否有 success 字段且为 false，或者有 code 字段且以 '010' 开头
          if ('success' in res && res.success === false || res.code && typeof res.code === 'string' && res.code.startsWith('010')) {
            const errorMsg = res.msg || '导出失败';
            ElMessage.error(errorMsg);
            return Promise.reject(new Error(errorMsg));
          }
        }
        // 调用下载函数（内部会进一步检查 Blob 内容）
        downloadFile(res, '计提证明材料.zip');
        return Promise.resolve();
      }).catch(error => {
        // 如果错误对象包含 msg，显示具体的错误消息
        if (error && typeof error === 'object' && error.msg) {
          ElMessage.error(error.msg);
        } else {
          ElMessage.error('导出失败');
        }
        return Promise.reject(error);
      });
    };

    // 获取审核状态文本
    const getstatusText = status => {
      const statusMap = {
        0: '编辑中',
        1: '审核通过',
        2: '待审核',
        '-1': '退回修改'
      };
      return statusMap[status] || '未知';
    };

    // 获取合同类型文本
    const getContractTypeText = contractType => {
      const contractTypeMap = {
        0: '广告投放',
        1: '活动宣传',
        2: '媒介监测'
      };
      return contractTypeMap[contractType] || '未知';
    };

    // 获取审核状态标签类型
    const getstatusType = status => {
      const typeMap = {
        0: 'info',
        1: 'success',
        2: 'warning',
        '-1': 'danger'
      };
      return typeMap[status] || 'info';
    };

    // 查看证明材料
    const handleViewProof = row => {
      proofDialog.visible = true;
      proofDialog.currentRow = row;
      proofDialog.fileList = row.fileList || [];
    };

    // 关闭证明材料对话框
    const closeProofDialog = () => {
      proofDialog.visible = false;
      proofDialog.currentRow = null;
      proofDialog.fileList = [];
    };

    // 删除证明材料（仅供应商）
    const handleDeleteProof = proof => {
      if (!props.userRole.isSupplier) {
        ElMessage.warning('只有供应商可以删除证明材料');
        return;
      }
      apis.deleteAccrueFiles({
        id: proof.id
      }).then(res => {
        if (res.success) {
          if (proofDialog.currentRow) {
            proofDialog.currentRow.fileList = proofDialog.currentRow.fileList.filter(item => item.id !== proof.id);
            proofDialog.fileList = proofDialog.currentRow.fileList;
          }
          ElMessage.success('删除成功');
        } else {
          ElMessage.error(res.message);
        }
      }).catch(err => {
        ElMessage.error(err);
      });
    };

    // 删除明细（仅管理员）
    const handleDeleteDetail = row => {
      apis.deleteAccrueDetail({
        id: row.id
      }).then(res => {
        if (res.success) {
          ElMessage.success('删除成功');
          loadData();
        }
      }).catch(err => {
        ElMessage.error(err);
      });
    };

    // 下载证明材料
    const handleDownloadProof = proof => {
      window.open(proof.fileUrl);
    };

    // 催办供应商（合同管理员，审核状态页，详情为编辑中时可用）
    const urgeLoading = ref(false);
    const handleUrge = row => {
      if (urgeLoading.value) return;
      urgeLoading.value = true;
      urgeAccrueDetail({
        detailId: row.id
      }).then(res => {
        if (res.success) {
          loadData();
          ElMessage.success('催办成功');
        } else {
          ElMessage.error(res.msg || res.message || '催办失败');
        }
      }).catch(err => {
        console.error('催办失败:', err);
        ElMessage.error('催办失败');
      }).finally(() => {
        urgeLoading.value = false;
      });
    };

    // 提交审核（供应商）
    const handleSubmitForAudit = row => {
      if (!props.userRole.isSupplier) {
        ElMessage.warning('只有供应商可以提交审核');
        return;
      }

      // 校验1: 检查所有数据异常的本月金额都需要有remark
      const abnormalAmountsWithoutRemark = [];

      // 检查各部门金额字段
      departments.forEach(dept => {
        const amountObj = getAmountObj(row, dept.prop);
        if (amountObj && amountObj.abnormal) {
          if (!amountObj.remark || amountObj.remark.trim() === '') {
            abnormalAmountsWithoutRemark.push(dept.name);
          }
        }
      });
      if (abnormalAmountsWithoutRemark.length > 0) {
        ElMessage.warning(`以下数据异常的本月金额需要填写原因说明：${abnormalAmountsWithoutRemark.join('、')}`);
        return;
      }

      // 校验2: 证明材料必须有至少一条
      const fileList = row.fileList || [];
      if (fileList.length === 0) {
        ElMessage.warning('证明材料必须有至少一条，请先上传证明材料');
        return;
      }
      apis.accrueCommitAudit({
        detailId: row.id
      }).then(res => {
        if (res.success) {
          loadData();
          ElMessage.success('提交成功');
        } else {
          ElMessage.error(res.message);
        }
      });
    };

    // 打开上传证明材料对话框（供应商）
    const handleUploadProof = row => {
      if (!props.userRole.isSupplier) {
        ElMessage.warning('只有供应商可以上传证明材料');
        return;
      }
      uploadProofDialog.visible = true;
      uploadProofDialog.currentRow = row;
    };

    // 关闭上传对话框
    const closeUploadDialog = () => {
      uploadProofDialog.visible = false;
      uploadProofDialog.currentRow = null;
    };

    // 处理上传成功回调
    const handleUploadSuccess = files => {
      if (!files || files.length === 0) {
        ElMessage.error('请先上传文件!');
        return;
      }

      // 转换文件格式
      const newProofs = files.map(f => ({
        fileId: f.id,
        fileName: f.fileName,
        fileUrl: f.relativeUrl,
        detailId: uploadProofDialog.currentRow.id
      }));
      apis.addAccrueFiles({
        fileList: newProofs
      }).then(res => {
        if (res.success) {
          if (uploadProofDialog.currentRow) {
            uploadProofDialog.currentRow.fileList.push(...newProofs);
          }
          loadData();
        } else {
          ElMessage.error('上传失败:' + res.msg);
        }
      }).catch(error => {
        console.error('上传失败:', error);
      }).finally(() => {
        closeUploadDialog();
      });
    };

    // 表格选择变化
    const handleSelectionChange = selection => {
      selectedRows.value = selection;
    };

    // 判断是否可以编辑（只有状态0和-1可以编辑）
    const canEdit = row => {
      if (props.type === 0) return false; // type为0时仅为查看，不做操作
      return row.status === 0 || row.status === -1;
    };

    // 获取金额对象
    const getAmountObj = (row, prop) => {
      if (!row.amountMap) return null;
      return row.amountMap[prop] || null;
    };

    // 合同管理员可编辑字段的编辑状态管理（参考ContractSettlementEdit.vue的实现）
    const editingDetailCell = reactive({
      rowId: null,
      columnLabel: '',
      originalValue: ''
    });

    // 供应商可编辑金额的编辑状态管理（截止当月）
    const editingAmountCell = reactive({
      rowId: null,
      prop: '',
      originalValue: ''
    });

    // 供应商可编辑金额的编辑状态管理（截止上月）
    const editingLastAmountCell = reactive({
      rowId: null,
      prop: '',
      originalValue: ''
    });

    // 判断字段是否可编辑（合同管理员可以编辑预算编码、预算名称、项目类型、备注）
    const canEditDetailField = columnLabel => {
      if (props.type === 0) return false; // type为0时仅为查看，不做操作
      if (!props.userRole.isAdmin) return false;
      const editableFields = ['预算编码', '预算名称', '项目类型', '广告项目', '备注'];
      return editableFields.includes(columnLabel);
    };

    // 判断金额单元格是否可编辑（供应商可以编辑金额列，仅可编辑编辑中、退回修改状态的行）
    const canEditAmountCell = (row, prop, columnName) => {
      if (columnName && columnName === 'last') return false; // 截止上月目前不能编辑
      if (props.type === 0) return false; // type为0时仅为查看，不做操作
      if (!props.userRole.isSupplier) return false;
      if (row.status !== 0 && row.status !== -1) return false; // 仅可编辑编辑中、退回修改状态
      if (prop === 'currentMonthTotal') return false; // 合计不能编辑
      if (row.contractUserId !== props.userRole.userId) return false; // 只能编辑自己负责的行
      const amountObj = getAmountObj(row, prop);
      return !!amountObj;
    };

    // 点击单元格开始编辑（仅用于合同管理员编辑字段）
    const handleCellClick = (row, column) => {
      // 合同管理员编辑字段
      if (canEditDetailField(column.label)) {
        const fieldProp = getFieldProp(column.label);
        editingDetailCell.rowId = row.id;
        editingDetailCell.columnLabel = column.label;
        editingDetailCell.originalValue = row[fieldProp] || '';
        // 等待DOM更新后聚焦输入框
        nextTick(() => {
          const input = document.querySelector(`.editing-detail-input-${row.id}-${fieldProp}`);
          if (input) {
            const elInput = input.querySelector('textarea') || input.querySelector('input');
            if (elInput) {
              elInput.focus();
              elInput.select();
            }
          }
        });
      }
    };

    // 保存编辑
    const saveDetailEdit = (row, columnLabel) => {
      if (!editingDetailCell.rowId || editingDetailCell.rowId !== row.id || editingDetailCell.columnLabel !== columnLabel) {
        return;
      }
      const fieldProp = getFieldProp(columnLabel);
      const originalValue = editingDetailCell.originalValue;
      const newValue = String(row[fieldProp] || '').trim();

      // 如果值没有变化，直接取消编辑
      if (newValue === originalValue) {
        editingDetailCell.rowId = null;
        editingDetailCell.columnLabel = '';
        editingDetailCell.originalValue = '';
        return;
      }

      // 构建更新数据
      const updateData = {
        id: row.id,
        [fieldProp]: newValue
      };

      // 调用编辑接口
      apis.updateAccrueDetail(updateData).then(response => {
        if (response.success) {
          ElMessage.success('更新成功');
          editingDetailCell.rowId = null;
          editingDetailCell.columnLabel = '';
          editingDetailCell.originalValue = '';
        } else {
          throw new Error(response.msg || '更新失败');
        }
      }).catch(error => {
        // 更新失败，恢复原始值并重新加载数据
        ElMessage.error(error.message || '更新失败');
        row[fieldProp] = originalValue;
        editingDetailCell.rowId = null;
        editingDetailCell.columnLabel = '';
        editingDetailCell.originalValue = '';
        // 重新加载数据
        loadData();
      });
    };

    // 预算编码、预算名称：保存时按合同类型批量更新（同 contractType 的所有行一起编辑）
    const UNIFIED_EDIT_COLUMNS = ['预算编码', '预算名称'];
    const saveDetailEditByContractType = (row, columnLabel) => {
      if (!UNIFIED_EDIT_COLUMNS.includes(columnLabel)) return;
      if (!editingDetailCell.rowId || editingDetailCell.rowId !== row.id || editingDetailCell.columnLabel !== columnLabel) {
        return;
      }
      const fieldProp = getFieldProp(columnLabel);
      const originalValue = editingDetailCell.originalValue;
      const newValue = String(row[fieldProp] || '').trim();
      if (newValue === originalValue) {
        editingDetailCell.rowId = null;
        editingDetailCell.columnLabel = '';
        editingDetailCell.originalValue = '';
        return;
      }
      const sameContractTypeRows = fullTableData.value.filter(r => r.contractType === row.contractType);
      const updatePromises = sameContractTypeRows.map(r => apis.updateAccrueDetail({
        id: r.id,
        [fieldProp]: newValue
      }));
      Promise.all(updatePromises).then(responses => {
        const allSuccess = responses.every(res => res && res.success);
        if (allSuccess) {
          sameContractTypeRows.forEach(r => {
            r[fieldProp] = newValue;
          });
          ElMessage.success(`已更新同合同类型的 ${sameContractTypeRows.length} 条记录的${columnLabel}`);
          editingDetailCell.rowId = null;
          editingDetailCell.columnLabel = '';
          editingDetailCell.originalValue = '';
        } else {
          var _responses$find;
          throw new Error(((_responses$find = responses.find(r => r && !r.success)) === null || _responses$find === void 0 ? void 0 : _responses$find.msg) || '部分更新失败');
        }
      }).catch(error => {
        ElMessage.error(error.message || '更新失败');
        row[fieldProp] = originalValue;
        editingDetailCell.rowId = null;
        editingDetailCell.columnLabel = '';
        editingDetailCell.originalValue = '';
        loadData();
      });
    };

    // 获取字段对应的prop
    const getFieldProp = columnLabel => {
      const fieldMap = {
        '预算编码': 'budgetCode',
        '预算名称': 'budgetName',
        '项目类型': 'projectType',
        '广告项目': 'adProject',
        '备注': 'remark'
      };
      return fieldMap[columnLabel] || '';
    };

    // 处理输入框回车事件（预算编码、预算名称走批量按合同类型保存，其他字段走单条保存）
    const handleDetailInputEnter = (event, row, columnLabel) => {
      if (event.shiftKey) return;
      event.preventDefault();
      event.stopPropagation();
      if (UNIFIED_EDIT_COLUMNS.includes(columnLabel)) {
        saveDetailEditByContractType(row, columnLabel);
      } else {
        saveDetailEdit(row, columnLabel);
      }
    };

    // 处理输入框失焦事件（预算编码、预算名称走批量按合同类型保存，其他字段走单条保存）
    const handleDetailInputBlur = (event, row, columnLabel) => {
      if (UNIFIED_EDIT_COLUMNS.includes(columnLabel)) {
        saveDetailEditByContractType(row, columnLabel);
      } else {
        saveDetailEdit(row, columnLabel);
      }
    };

    // 判断单元格是否正在编辑
    const isEditingDetailCell = (row, columnLabel) => {
      return editingDetailCell.rowId === row.id && editingDetailCell.columnLabel === columnLabel;
    };

    // 判断金额单元格是否正在编辑
    const isEditingAmountCell = (row, prop) => {
      return editingAmountCell.rowId === row.id && editingAmountCell.prop === prop;
    };

    // 保存金额编辑
    const saveAmountEdit = (row, prop, value) => {
      if (!editingAmountCell.rowId || editingAmountCell.rowId !== row.id || editingAmountCell.prop !== prop) {
        return;
      }
      const amountObj = getAmountObj(row, prop);
      if (!amountObj) return;
      const originalValue = editingAmountCell.originalValue;
      const newValue = String(value || amountObj.currentAmount || '0').trim();

      // 验证输入值
      const numValue = parseFloat(newValue);
      if (isNaN(numValue) || numValue < 0) {
        ElMessage.warning('请输入有效的数字（大于等于0）');
        amountObj.currentAmount = originalValue;
        editingAmountCell.rowId = null;
        editingAmountCell.prop = '';
        editingAmountCell.originalValue = '';
        return;
      }

      // 如果值没有变化，直接取消编辑
      const formattedValue = numValue.toFixed(2);
      if (formattedValue === originalValue) {
        editingAmountCell.rowId = null;
        editingAmountCell.prop = '';
        editingAmountCell.originalValue = '';
        return;
      }

      // 临时更新显示值
      amountObj.currentAmount = formattedValue;

      // 调用编辑接口，传递完整的单元格对象
      apis.updateAccrueAmount(amountObj).then(response => {
        if (response.success) {
          ElMessage.success('更新成功');
          editingAmountCell.rowId = null;
          editingAmountCell.prop = '';
          editingAmountCell.originalValue = '';
          // 重新加载数据以获取最新的异常检测结果
          loadData();
        } else {
          throw new Error(response.msg || '更新失败');
        }
      }).catch(error => {
        // 更新失败，恢复原始值
        ElMessage.error(error.message || '更新失败');
        amountObj.currentAmount = originalValue;
        editingAmountCell.rowId = null;
        editingAmountCell.prop = '';
        editingAmountCell.originalValue = '';
      });
    };

    // 处理金额输入框回车事件
    const handleAmountInputEnter = (event, row, prop) => {
      event.preventDefault();
      event.stopPropagation();
      const amountObj = getAmountObj(row, prop);
      if (amountObj) {
        saveAmountEdit(row, prop, amountObj.currentAmount);
      }
    };

    // 处理金额输入框失焦事件
    const handleAmountInputBlur = (event, row, prop) => {
      const amountObj = getAmountObj(row, prop);
      if (amountObj) {
        saveAmountEdit(row, prop, amountObj.currentAmount);
      }
    };

    // 点击金额单元格开始编辑
    const handleAmountCellClick = (row, prop) => {
      if (!canEditAmountCell(row, prop)) return;
      const amountObj = getAmountObj(row, prop);
      editingAmountCell.rowId = row.id;
      editingAmountCell.prop = prop;
      editingAmountCell.originalValue = (amountObj === null || amountObj === void 0 ? void 0 : amountObj.currentAmount) || '0.00';
      // 等待DOM更新后聚焦输入框
      nextTick(() => {
        const input = document.querySelector(`.editing-amount-input-${row.id}-${prop}`);
        if (input) {
          const elInput = input.querySelector('input');
          if (elInput) {
            elInput.focus();
            elInput.select();
          }
        }
      });
    };

    // 判断截止上月金额单元格是否正在编辑
    const isEditingLastAmountCell = (row, prop) => {
      return editingLastAmountCell.rowId === row.id && editingLastAmountCell.prop === prop;
    };

    // 点击截止上月金额单元格开始编辑
    const handleLastAmountCellClick = (row, prop) => {
      if (!canEditAmountCell(row, prop)) return;
      const amountObj = getAmountObj(row, prop);
      editingLastAmountCell.rowId = row.id;
      editingLastAmountCell.prop = prop;
      editingLastAmountCell.originalValue = (amountObj === null || amountObj === void 0 ? void 0 : amountObj.lastAmount) || '0.00';
      // 等待DOM更新后聚焦输入框
      nextTick(() => {
        const input = document.querySelector(`.editing-last-amount-input-${row.id}-${prop}`);
        if (input) {
          const elInput = input.querySelector('input');
          if (elInput) {
            elInput.focus();
            elInput.select();
          }
        }
      });
    };

    // 保存截止上月金额编辑
    const saveLastAmountEdit = (row, prop, value) => {
      if (!editingLastAmountCell.rowId || editingLastAmountCell.rowId !== row.id || editingLastAmountCell.prop !== prop) {
        return;
      }
      const amountObj = getAmountObj(row, prop);
      if (!amountObj) return;
      const originalValue = editingLastAmountCell.originalValue;
      const newValue = String(value || amountObj.lastAmount || '0').trim();

      // 验证输入值
      const numValue = parseFloat(newValue);
      if (isNaN(numValue) || numValue < 0) {
        ElMessage.warning('请输入有效的数字（大于等于0）');
        amountObj.lastAmount = originalValue;
        editingLastAmountCell.rowId = null;
        editingLastAmountCell.prop = '';
        editingLastAmountCell.originalValue = '';
        return;
      }

      // 如果值没有变化，直接取消编辑
      const formattedValue = numValue.toFixed(2);
      if (formattedValue === originalValue) {
        editingLastAmountCell.rowId = null;
        editingLastAmountCell.prop = '';
        editingLastAmountCell.originalValue = '';
        return;
      }

      // 临时更新显示值
      amountObj.lastAmount = formattedValue;

      // 调用编辑接口，传递完整的单元格对象
      apis.updateAccrueAmount(amountObj).then(response => {
        if (response.success) {
          ElMessage.success('更新成功');
          editingLastAmountCell.rowId = null;
          editingLastAmountCell.prop = '';
          editingLastAmountCell.originalValue = '';
          // 重新加载数据以获取最新的异常检测结果
          loadData();
        } else {
          throw new Error(response.msg || '更新失败');
        }
      }).catch(error => {
        // 更新失败，恢复原始值
        ElMessage.error(error.message || '更新失败');
        amountObj.lastAmount = originalValue;
        editingLastAmountCell.rowId = null;
        editingLastAmountCell.prop = '';
        editingLastAmountCell.originalValue = '';
      });
    };

    // 处理截止上月金额输入框回车事件
    const handleLastAmountInputEnter = (event, row, prop) => {
      event.preventDefault();
      event.stopPropagation();
      const amountObj = getAmountObj(row, prop);
      if (amountObj) {
        saveLastAmountEdit(row, prop, amountObj.lastAmount);
      }
    };

    // 处理截止上月金额输入框失焦事件
    const handleLastAmountInputBlur = (event, row, prop) => {
      const amountObj = getAmountObj(row, prop);
      if (amountObj) {
        saveLastAmountEdit(row, prop, amountObj.lastAmount);
      }
    };

    // 右键菜单相关
    const contextMenu = reactive({
      visible: false,
      x: 0,
      y: 0,
      row: null,
      prop: ''
    });

    // 处理金额单元格右键点击
    const handleAmountCellRightClick = (event, row, prop) => {
      if (!canEditAmountCell(row, prop)) return; // 通过 canEditAmountCell 控制，内部已包含 type !== 0 判断
      const amountObj = getAmountObj(row, prop);
      if (!amountObj || !amountObj.abnormal) return; // 只有异常数据才显示右键菜单

      event.preventDefault();
      event.stopPropagation();
      contextMenu.visible = true;
      contextMenu.x = event.clientX;
      contextMenu.y = event.clientY;
      contextMenu.row = row;
      contextMenu.prop = prop;

      // 点击外部关闭菜单
      nextTick(() => {
        const closeMenu = e => {
          if (!e.target.closest('.context-menu')) {
            closeContextMenu();
            document.removeEventListener('click', closeMenu);
          }
        };
        document.addEventListener('click', closeMenu);
      });
    };

    // 关闭右键菜单
    const closeContextMenu = () => {
      contextMenu.visible = false;
      contextMenu.row = null;
      contextMenu.prop = '';
    };

    // 打开原因说明对话框
    const reasonDialog = reactive({
      visible: false,
      row: null,
      prop: '',
      remark: ''
    });
    const openReasonDialog = () => {
      if (!contextMenu.row || !contextMenu.prop) return;
      const amountObj = getAmountObj(contextMenu.row, contextMenu.prop);
      reasonDialog.visible = true;
      reasonDialog.row = contextMenu.row;
      reasonDialog.prop = contextMenu.prop;
      reasonDialog.remark = (amountObj === null || amountObj === void 0 ? void 0 : amountObj.remark) || '';
      closeContextMenu();
    };

    // 保存原因说明
    const saveReason = () => {
      if (!reasonDialog.row || !reasonDialog.prop) return;
      const amountObj = getAmountObj(reasonDialog.row, reasonDialog.prop);
      if (!amountObj) return;
      const originalRemark = amountObj.remark || '';
      const newRemark = reasonDialog.remark.trim();

      // 如果值没有变化，直接关闭
      if (newRemark === originalRemark) {
        reasonDialog.visible = false;
        return;
      }

      // 临时更新显示值
      amountObj.remark = newRemark;

      // 调用编辑接口，传递完整的单元格对象（只更新remark）
      apis.updateAccrueAmount(amountObj).then(response => {
        if (response.success) {
          ElMessage.success('原因说明保存成功');
          reasonDialog.visible = false;
          // 重新加载数据
          loadData();
        } else {
          throw new Error(response.msg || '保存失败');
        }
      }).catch(error => {
        // 保存失败，恢复原始值
        ElMessage.error(error.message || '保存失败');
        amountObj.remark = originalRemark;
      });
    };

    // 获取表头单元格样式
    const getHeaderCellStyle = ({
      column,
      columnIndex
    }) => {
      const label = column.label || '';
      const prop = column.property || '';
      // 当月发生金额模块
      if (label === '当月发生金额（不含税）' || currentMonthAmountCategories.some(cat => cat.prop === prop)) {
        return {
          backgroundColor: '#F0F9FF',
          color: '#333'
        };
      }
      // 截止当月合同已累计使用不含税金额模块
      if (label === '截止当月合同已累计使用不含税金额（元）' || label === '截止当月合计' || departments.some(dept => dept.name === label) || label === '截止当月' || label === '截止上月') {
        return {
          backgroundColor: '#F5F0FF',
          color: '#333'
        };
      }
      // 默认样式
      return {
        backgroundColor: '#ECF5FF',
        color: '#333'
      };
    };

    // 获取单元格样式
    const getCellStyle = ({
      row,
      column,
      columnIndex
    }) => {
      const prop = column.property;
      // 根据合同类型和列属性设置背景色
      if (prop === 'budgetCode' || prop === 'budgetName') {
        if (row.contractType === 0) {
          return {
            backgroundColor: '#f0fbff'
          };
        }
        if (row.contractType === 1) {
          return {
            backgroundColor: '#f5fff0'
          };
        }
        if (row.contractType === 2) {
          return {
            backgroundColor: '#fffef0'
          };
        }
      }
      return {};
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_upload = _resolveComponent("el-upload");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: dialogTitle.value,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        fullscreen: "",
        "append-to-body": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: openMonthProofTemplateDialog
        }, {
          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("计提证明材料模板", -1)]))]),
          _: 1
        }), __props.userRole.isSupplier ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: exportTemp
        }, {
          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode("导出填写", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: importTemp
        }, {
          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode("导入填写", -1)]))]),
          _: 1
        })], 64)) : _createCommentVNode("", true), __props.userRole.isAdmin ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [__props.type === 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: handleBatchAudit
        }, {
          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("批量审核", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: _cache[0] || (_cache[0] = $event => handleExportDetail(1))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tooltip, {
            content: "导出当前月份已审核通过的详情"
          }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" 导出详情 ", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: _cache[1] || (_cache[1] = $event => handleExportDetail(2))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tooltip, {
            content: "导出当前月份已审核通过的详情"
          }, {
            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode(" 导出PDF ", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: handleExportProof
        }, {
          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("导出证明材料", -1)]))]),
          _: 1
        })], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref_key: "tableRef",
          ref: tableRef,
          data: filteredTableData.value,
          style: {
            "width": "100%"
          },
          border: "",
          height: tableHeight.value,
          "header-cell-style": getHeaderCellStyle,
          "cell-style": getCellStyle,
          onSelectionChange: handleSelectionChange,
          onCellClick: handleCellClick
        }, {
          default: _withCtx(() => [__props.type === 1 ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            type: "selection",
            width: "55",
            fixed: "left"
          })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
            label: "预算编码",
            prop: "budgetCode",
            width: "120",
            fixed: "left"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[32] || (_cache[32] = _createElementVNode("span", null, "预算编码", -1)), _createVNode(_component_el_tooltip, null, {
              content: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode(" 预算编码、预算名称、项目类型、备注这四列在添加计提任务时，", -1), _createElementVNode("br", null, null, -1), _createTextVNode(" 会继承该合同在该年份上一个最近月份的内容 ", -1)]))]),
              default: _withCtx(() => [_createVNode(_unref(InfoFilled), {
                class: "info-icon-line"
              })]),
              _: 1
            })]), _createVNode(_component_el_select, {
              modelValue: headerFilters.budgetCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => headerFilters.budgetCode = $event),
              multiple: "",
              "collapse-tags": "",
              clearable: "",
              filterable: "",
              placeholder: "全部",
              class: "header-filter-select"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDistinctOptions('budgetCode'), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `budgetCode-${item.value}`,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            default: _withCtx(scope => [isEditingDetailCell(scope.row, '预算编码') ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([`editing-detail-input-${scope.row.id}-budgetCode`, "editing-detail-cell"])
            }, [_createVNode(_component_el_input, {
              modelValue: scope.row.budgetCode,
              "onUpdate:modelValue": $event => scope.row.budgetCode = $event,
              type: "textarea",
              autosize: {
                minRows: 2
              },
              maxlength: "300",
              placeholder: "请输入预算编码",
              onKeydown: _withKeys($event => handleDetailInputEnter($event, scope.row, '预算编码'), ["enter"]),
              onBlur: $event => handleDetailInputBlur($event, scope.row, '预算编码')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onBlur"])], 2)) : (_openBlock(), _createBlock(_component_el_text, {
              key: 1,
              class: "detail-cell-text",
              style: {
                "color": "#5186ef"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.budgetCode), 1)]),
              _: 2
            }, 1024))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "预算名称",
            prop: "budgetName",
            width: "120",
            fixed: "left"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[33] || (_cache[33] = _createElementVNode("div", {
              class: "header-title"
            }, "预算名称", -1)), _createVNode(_component_el_select, {
              modelValue: headerFilters.budgetName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => headerFilters.budgetName = $event),
              multiple: "",
              "collapse-tags": "",
              filterable: "",
              clearable: "",
              placeholder: "全部",
              class: "header-filter-select"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDistinctOptions('budgetName'), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `budgetName-${item.value}`,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            default: _withCtx(scope => [isEditingDetailCell(scope.row, '预算名称') ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([`editing-detail-input-${scope.row.id}-budgetName`, "editing-detail-cell"])
            }, [_createVNode(_component_el_input, {
              modelValue: scope.row.budgetName,
              "onUpdate:modelValue": $event => scope.row.budgetName = $event,
              type: "textarea",
              autosize: {
                minRows: 2
              },
              maxlength: "300",
              placeholder: "请输入预算名称",
              onKeydown: _withKeys($event => handleDetailInputEnter($event, scope.row, '预算名称'), ["enter"]),
              onBlur: $event => handleDetailInputBlur($event, scope.row, '预算名称')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onBlur"])], 2)) : (_openBlock(), _createBlock(_component_el_text, {
              key: 1,
              class: "detail-cell-text",
              style: {
                "color": "#5186ef"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.budgetName), 1)]),
              _: 2
            }, 1024))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "序号",
            prop: "indexNum",
            width: "60",
            fixed: "left"
          }), _createVNode(_component_el_table_column, {
            label: "项目类型",
            prop: "projectType",
            width: "110",
            fixed: "left"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_cache[34] || (_cache[34] = _createElementVNode("div", {
              class: "header-title"
            }, "项目类型", -1)), _createVNode(_component_el_select, {
              modelValue: headerFilters.projectType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => headerFilters.projectType = $event),
              multiple: "",
              "collapse-tags": "",
              filterable: "",
              clearable: "",
              placeholder: "全部",
              class: "header-filter-select"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDistinctOptions('projectType'), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `projectType-${item.value}`,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            default: _withCtx(scope => [isEditingDetailCell(scope.row, '项目类型') ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([`editing-detail-input-${scope.row.id}-projectType`, "editing-detail-cell"])
            }, [_createVNode(_component_el_input, {
              modelValue: scope.row.projectType,
              "onUpdate:modelValue": $event => scope.row.projectType = $event,
              type: "textarea",
              autosize: {
                minRows: 2
              },
              maxlength: "300",
              placeholder: "请输入项目类型",
              onKeydown: _withKeys($event => handleDetailInputEnter($event, scope.row, '项目类型'), ["enter"]),
              onBlur: $event => handleDetailInputBlur($event, scope.row, '项目类型')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onBlur"])], 2)) : (_openBlock(), _createBlock(_component_el_text, {
              key: 1,
              class: "detail-cell-text",
              style: {
                "color": "#5186ef"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.projectType), 1)]),
              _: 2
            }, 1024))]),
            _: 1
          }), __props.userRole.isAdmin ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            label: "备注",
            prop: "remark",
            width: "150",
            fixed: "left"
          }, {
            header: _withCtx(() => [_createElementVNode("span", null, [_cache[36] || (_cache[36] = _createTextVNode("备注 ", -1)), _createVNode(_component_el_tooltip, null, {
              content: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode(" 备注信息,用于记录供应商计提信息，会作为导出证明材料的命名依据 ", -1), _createElementVNode("br", null, null, -1), _createTextVNode(" 如: 计提：【CMYN-202500875】博雅星空（抖音）2025年11月广告宣传费 ", -1), _createElementVNode("br", null, null, -1), _createTextVNode(" 证明材料命名：1.1 CMYN-202500875 博雅星空（抖音）2025年11月证明材料.pdf ", -1), _createElementVNode("br", null, null, -1), _createElementVNode("br", null, null, -1), _createTextVNode(" 备注在导出时，会放到表格末尾 ", -1)]))]),
              default: _withCtx(() => [_createVNode(_unref(InfoFilled), {
                class: "info-icon-line"
              })]),
              _: 1
            })])]),
            default: _withCtx(scope => [isEditingDetailCell(scope.row, '备注') ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([`editing-detail-input-${scope.row.id}-remark`, "editing-detail-cell"])
            }, [_createVNode(_component_el_input, {
              modelValue: scope.row.remark,
              "onUpdate:modelValue": $event => scope.row.remark = $event,
              type: "textarea",
              autosize: {
                minRows: 2
              },
              maxlength: "300",
              placeholder: "请输入备注",
              onKeydown: _withKeys($event => handleDetailInputEnter($event, scope.row, '备注'), ["enter"]),
              onBlur: $event => handleDetailInputBlur($event, scope.row, '备注')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onBlur"])], 2)) : (_openBlock(), _createBlock(_component_el_text, {
              key: 1,
              class: "detail-cell-text",
              style: {
                "color": "#5186ef"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.remark), 1)]),
              _: 2
            }, 1024))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
            label: "合同编号",
            prop: "contractCode",
            width: "120",
            fixed: "left"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_cache[37] || (_cache[37] = _createElementVNode("div", {
              class: "header-title"
            }, "合同编号", -1)), _createVNode(_component_el_select, {
              modelValue: headerFilters.contractCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => headerFilters.contractCode = $event),
              multiple: "",
              "collapse-tags": "",
              clearable: "",
              filterable: "",
              placeholder: "全部",
              class: "header-filter-select"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDistinctOptions('contractCode'), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `contractCode-${item.value}`,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "合同名称",
            prop: "contractName",
            width: "200",
            fixed: "left"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_cache[38] || (_cache[38] = _createElementVNode("div", {
              class: "header-title"
            }, "合同名称", -1)), _createVNode(_component_el_select, {
              modelValue: headerFilters.contractName,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => headerFilters.contractName = $event),
              multiple: "",
              "collapse-tags": "",
              clearable: "",
              filterable: "",
              placeholder: "全部",
              class: "header-filter-select"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDistinctOptions('contractName'), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `contractName-${item.value}`,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "广告项目",
            prop: "adProject",
            width: "160",
            fixed: "left"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_cache[39] || (_cache[39] = _createElementVNode("div", {
              class: "header-title"
            }, "广告项目", -1)), _createVNode(_component_el_select, {
              modelValue: headerFilters.adProject,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => headerFilters.adProject = $event),
              multiple: "",
              "collapse-tags": "",
              clearable: "",
              filterable: "",
              placeholder: "全部",
              class: "header-filter-select"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDistinctOptions('adProject'), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `adProject-${item.value}`,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            default: _withCtx(scope => [isEditingDetailCell(scope.row, '广告项目') ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([`editing-detail-input-${scope.row.id}-adProject`, "editing-detail-cell"])
            }, [_createVNode(_component_el_input, {
              modelValue: scope.row.adProject,
              "onUpdate:modelValue": $event => scope.row.adProject = $event,
              type: "textarea",
              autosize: {
                minRows: 2
              },
              maxlength: "300",
              placeholder: "请输入广告项目",
              onKeydown: _withKeys($event => handleDetailInputEnter($event, scope.row, '广告项目'), ["enter"]),
              onBlur: $event => handleDetailInputBlur($event, scope.row, '广告项目')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onBlur"])], 2)) : (_openBlock(), _createBlock(_component_el_text, {
              key: 1,
              class: "detail-cell-text",
              style: {
                "color": "#5186ef"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.adProject), 1)]),
              _: 2
            }, 1024))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "合同金额",
            prop: "contractAmount",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            label: "供应商",
            prop: "supplier",
            width: "120"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_cache[40] || (_cache[40] = _createElementVNode("div", {
              class: "header-title"
            }, "供应商", -1)), _createVNode(_component_el_select, {
              modelValue: headerFilters.supplier,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => headerFilters.supplier = $event),
              multiple: "",
              "collapse-tags": "",
              clearable: "",
              filterable: "",
              placeholder: "全部",
              class: "header-filter-select"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDistinctOptions('supplier'), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `supplier-${item.value}`,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "合同期限",
            prop: "contractPeriod",
            width: "120"
          }), _createVNode(_component_el_table_column, {
            label: "审核状态",
            prop: "status",
            width: "110",
            fixed: "left"
          }, {
            header: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_cache[41] || (_cache[41] = _createElementVNode("div", {
              class: "header-title"
            }, "审核状态", -1)), _createVNode(_component_el_select, {
              modelValue: headerFilters.status,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => headerFilters.status = $event),
              multiple: "",
              "collapse-tags": "",
              clearable: "",
              filterable: "",
              placeholder: "全部",
              class: "header-filter-select"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDistinctOptions('status'), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: `status-${item.value}`,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]),
            default: _withCtx(scope => [_createVNode(_component_el_tag, {
              type: getstatusType(scope.row.status),
              size: "small"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(getstatusText(scope.row.status)), 1)]),
              _: 2
            }, 1032, ["type"]), scope.row.status === 0 || scope.row.status === -1 ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: getstatusType(scope.row.status),
              size: "small"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.contractUserName), 1)]),
              _: 2
            }, 1032, ["type"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "审核信息",
            fixed: "left",
            width: "120"
          }, {
            header: _withCtx(() => [_createElementVNode("span", null, [_cache[43] || (_cache[43] = _createTextVNode("审核信息 ", -1)), _createVNode(_component_el_tooltip, null, {
              content: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createTextVNode(" 审核状态和审核信息，仅在网页中展示，导出表格时不会显示 ", -1)]))]),
              default: _withCtx(() => [_createVNode(_unref(InfoFilled), {
                class: "info-icon-line"
              })]),
              _: 1
            })])]),
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.auditDescription), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "当月发生金额（不含税）",
            align: "center"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(currentMonthAmountCategories, category => {
              return _createVNode(_component_el_table_column, {
                key: category.prop,
                label: category.name,
                prop: category.prop,
                width: "100px"
              }, {
                header: _withCtx(() => [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(category.name) + " ", 1), category.name === '家庭市场业务' ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  content: "(宽带、电视盒子、智能网关、智能门锁、安防监控、FTTR及以家庭命名的业务等)"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(InfoFilled), {
                    class: "info-icon-line"
                  })]),
                  _: 1
                })) : _createCommentVNode("", true)])]),
                default: _withCtx(scope => {
                  var _getAmountObj, _getAmountObj2;
                  return [category.prop === 'currentMonthTotal' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(calculateTotal(scope.row, currentMonthAmountCategories)), 1)])) : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "cell-content",
                    onContextmenu: _withModifiers($event => handleAmountCellRightClick($event, scope.row, category.prop), ["prevent"])
                  }, [canEditAmountCell(scope.row, category.prop) && isEditingAmountCell(scope.row, category.prop) ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_el_input, {
                    class: _normalizeClass(`editing-amount-input-${scope.row.id}-${category.prop}`),
                    "model-value": ((_getAmountObj = getAmountObj(scope.row, category.prop)) === null || _getAmountObj === void 0 ? void 0 : _getAmountObj.currentAmount) || '0.00',
                    "onUpdate:modelValue": val => {
                      if (getAmountObj(scope.row, category.prop)) getAmountObj(scope.row, category.prop).currentAmount = val;
                    },
                    onKeyup: _withKeys($event => handleAmountInputEnter($event, scope.row, category.prop), ["enter"]),
                    onBlur: $event => handleAmountInputBlur($event, scope.row, category.prop)
                  }, null, 8, ["class", "model-value", "onUpdate:modelValue", "onKeyup", "onBlur"])])) : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["amount-cell-display", {
                      'editable-amount': canEditAmountCell(scope.row, category.prop)
                    }]),
                    onClick: $event => handleAmountCellClick(scope.row, category.prop)
                  }, [_createElementVNode("span", null, _toDisplayString(((_getAmountObj2 = getAmountObj(scope.row, category.prop)) === null || _getAmountObj2 === void 0 ? void 0 : _getAmountObj2.currentAmount) || '0.00'), 1)], 10, _hoisted_15))], 40, _hoisted_13))];
                }),
                _: 2
              }, 1032, ["label", "prop"]);
            }), 64))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "截止当月合同已累计使用不含税金额（元）",
            align: "center"
          }, {
            header: _withCtx(() => [_createElementVNode("span", null, [_cache[45] || (_cache[45] = _createTextVNode("截止当月合同已累计使用不含税金额（元） ", -1)), _createVNode(_component_el_tooltip, null, {
              content: _withCtx(() => [...(_cache[44] || (_cache[44] = [_createTextVNode(" 金额异常说明：", -1), _createElementVNode("br", null, null, -1), _createTextVNode(" 1、如果填写的本月各部门（市场部除外）累计使用金额数据低于前一个月金额，则为异常金额", -1), _createElementVNode("br", null, null, -1), _createTextVNode(" 2、如果填写的本月市场部累计使用金额小于(本月合计金额+上一个月市场部累计使用金额)，则为异常金额", -1), _createElementVNode("br", null, null, -1), _createTextVNode(" 金额标红为异常金额，需要供应商右键点击金额，打开右键菜单，选择异常说明选项，填写异常说明", -1), _createElementVNode("br", null, null, -1)]))]),
              default: _withCtx(() => [_createVNode(_unref(InfoFilled), {
                class: "info-icon-line"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "截止当月合计",
              width: "100"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(calculateTotal(scope.row, departments)), 1)])]),
              _: 1
            }), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(departments, dept => {
              return _createVNode(_component_el_table_column, {
                key: dept.prop,
                label: dept.name,
                width: "100"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  label: "截止当月",
                  prop: `${dept.prop}-current`,
                  width: "100"
                }, {
                  default: _withCtx(scope => {
                    var _getAmountObj3, _getAmountObj4, _getAmountObj5, _getAmountObj6, _getAmountObj7;
                    return [_createElementVNode("div", {
                      class: "cell-content",
                      onContextmenu: _withModifiers($event => handleAmountCellRightClick($event, scope.row, dept.prop), ["prevent"])
                    }, [canEditAmountCell(scope.row, dept.prop, 'current') && isEditingAmountCell(scope.row, dept.prop) ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_input, {
                      class: _normalizeClass(`editing-amount-input-${scope.row.id}-${dept.prop}`),
                      "model-value": ((_getAmountObj3 = getAmountObj(scope.row, dept.prop)) === null || _getAmountObj3 === void 0 ? void 0 : _getAmountObj3.currentAmount) || '0.00',
                      "onUpdate:modelValue": val => {
                        if (getAmountObj(scope.row, dept.prop)) getAmountObj(scope.row, dept.prop).currentAmount = val;
                      },
                      onKeyup: _withKeys($event => handleAmountInputEnter($event, scope.row, dept.prop), ["enter"]),
                      onBlur: $event => handleAmountInputBlur($event, scope.row, dept.prop)
                    }, null, 8, ["class", "model-value", "onUpdate:modelValue", "onKeyup", "onBlur"])])) : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["amount-cell-display", {
                        'editable-amount': canEditAmountCell(scope.row, dept.prop)
                      }]),
                      onClick: $event => handleAmountCellClick(scope.row, dept.prop)
                    }, [_createElementVNode("span", {
                      class: _normalizeClass({
                        'error-text': (_getAmountObj4 = getAmountObj(scope.row, dept.prop)) === null || _getAmountObj4 === void 0 ? void 0 : _getAmountObj4.abnormal
                      })
                    }, _toDisplayString(((_getAmountObj5 = getAmountObj(scope.row, dept.prop)) === null || _getAmountObj5 === void 0 ? void 0 : _getAmountObj5.currentAmount) || '0.00'), 3), (_getAmountObj6 = getAmountObj(scope.row, dept.prop)) !== null && _getAmountObj6 !== void 0 && _getAmountObj6.abnormal && (_getAmountObj7 = getAmountObj(scope.row, dept.prop)) !== null && _getAmountObj7 !== void 0 && _getAmountObj7.remark ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      effect: "dark",
                      placement: "top"
                    }, {
                      content: _withCtx(() => {
                        var _getAmountObj8;
                        return [_createTextVNode(_toDisplayString((_getAmountObj8 = getAmountObj(scope.row, dept.prop)) === null || _getAmountObj8 === void 0 ? void 0 : _getAmountObj8.remark), 1)];
                      }),
                      default: _withCtx(() => [_cache[46] || (_cache[46] = _createElementVNode("span", {
                        class: "error-icon"
                      }, "⚠", -1))]),
                      _: 2
                    }, 1024)) : _createCommentVNode("", true)], 10, _hoisted_19))], 40, _hoisted_17)];
                  }),
                  _: 2
                }, 1032, ["prop"]), __props.userRole.isSupplier ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "截止上月",
                  prop: `${dept.prop}-last`,
                  width: "100"
                }, {
                  default: _withCtx(scope => {
                    var _getAmountObj9, _getAmountObj0;
                    return [_createElementVNode("div", _hoisted_20, [canEditAmountCell(scope.row, dept.prop, 'last') && isEditingLastAmountCell(scope.row, dept.prop) ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_el_input, {
                      class: _normalizeClass(`editing-last-amount-input-${scope.row.id}-${dept.prop}`),
                      "model-value": ((_getAmountObj9 = getAmountObj(scope.row, dept.prop)) === null || _getAmountObj9 === void 0 ? void 0 : _getAmountObj9.lastAmount) || '0.00',
                      "onUpdate:modelValue": val => {
                        if (getAmountObj(scope.row, dept.prop)) getAmountObj(scope.row, dept.prop).lastAmount = val;
                      },
                      onKeyup: _withKeys($event => handleLastAmountInputEnter($event, scope.row, dept.prop), ["enter"]),
                      onBlur: $event => handleLastAmountInputBlur($event, scope.row, dept.prop)
                    }, null, 8, ["class", "model-value", "onUpdate:modelValue", "onKeyup", "onBlur"])])) : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["amount-cell-display", {
                        'editable-amount': canEditAmountCell(scope.row, dept.prop, 'last')
                      }]),
                      onClick: $event => handleLastAmountCellClick(scope.row, dept.prop)
                    }, [_createElementVNode("span", null, _toDisplayString(((_getAmountObj0 = getAmountObj(scope.row, dept.prop)) === null || _getAmountObj0 === void 0 ? void 0 : _getAmountObj0.lastAmount) || '0.00'), 1)], 10, _hoisted_22))])];
                  }),
                  _: 2
                }, 1032, ["prop"])) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["label"]);
            }), 64))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "140",
            fixed: "right"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", _hoisted_23, [__props.type === 1 && scope.row.status === 2 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => handleSingleAudit(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[47] || (_cache[47] = [_createTextVNode(" 审核 ", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true), __props.type === 1 && __props.userRole.isAdmin && scope.row.status === 0 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              link: "",
              type: "primary",
              size: "small",
              loading: urgeLoading.value,
              onClick: $event => handleUrge(scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString((scope.row.urgeCount || 0) > 0 ? `催办(已催办${scope.row.urgeCount}次)` : '催办'), 1)]),
              _: 2
            }, 1032, ["loading", "onClick"])) : _createCommentVNode("", true), __props.type !== 0 && __props.userRole.isSupplier && canEdit(scope.row) && __props.userRole.userId === scope.row.contractUserId ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => handleSubmitForAudit(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[48] || (_cache[48] = [_createTextVNode(" 提交审核 ", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true), __props.type !== 0 && __props.userRole.isSupplier && canEdit(scope.row) && __props.userRole.userId === scope.row.contractUserId ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => handleUploadProof(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode(" 上传证明材料 ", -1)]))]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => handleViewProof(scope.row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 查看证明材料(" + _toDisplayString((scope.row.fileList || []).length) + ") ", 1)]),
              _: 2
            }, 1032, ["onClick"]), __props.userRole.isAdmin && __props.type === 1 ? (_openBlock(), _createBlock(_component_el_popconfirm, {
              key: 4,
              class: "box-item",
              title: "是否确认删除该明细？",
              placement: "bottom-end",
              onConfirm: $event => handleDeleteDetail(scope.row)
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                link: "",
                type: "danger",
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[50] || (_cache[50] = [_createTextVNode(" 删除 ", -1)]))]),
                _: 1
              })]),
              _: 1
            }, 8, ["onConfirm"])) : _createCommentVNode("", true)])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "height"])), [[_directive_loading, loading.value]])]), _createVNode(_component_el_dialog, {
          modelValue: auditDialog.visible,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => auditDialog.visible = $event),
          title: "审核",
          width: "500px",
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_24, [_createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = $event => auditDialog.visible = false)
          }, {
            default: _withCtx(() => [...(_cache[53] || (_cache[53] = [_createTextVNode("取消", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSubmitAudit
          }, {
            default: _withCtx(() => [...(_cache[54] || (_cache[54] = [_createTextVNode("确定", -1)]))]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            model: auditDialog,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "审核结果",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: auditDialog.auditResult,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => auditDialog.auditResult = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 1
                }, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [_createTextVNode("通过", -1)]))]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: -1
                }, {
                  default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode("不通过", -1)]))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "审核描述",
              required: auditDialog.auditResult === -1
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: auditDialog.auditDesc,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => auditDialog.auditDesc = $event),
                type: "textarea",
                rows: 4,
                placeholder: "请输入审核描述"
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["required"])]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: proofDialog.visible,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => proofDialog.visible = $event),
          title: "查看证明材料",
          width: "600px",
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_27, [_createVNode(_component_el_button, {
            onClick: closeProofDialog
          }, {
            default: _withCtx(() => [...(_cache[58] || (_cache[58] = [_createTextVNode("关闭", -1)]))]),
            _: 1
          })])]),
          default: _withCtx(() => [proofDialog.fileList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[55] || (_cache[55] = [_createElementVNode("p", null, "暂无证明材料", -1)]))])) : (_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: proofDialog.fileList,
            border: "",
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "fileName",
              label: "文件名",
              width: "300"
            }), _createVNode(_component_el_table_column, {
              prop: "updateTime",
              label: "上传时间",
              width: "180"
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "120"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: $event => handleDownloadProof(scope.row)
              }, {
                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [_createTextVNode(" 下载 ", -1)]))]),
                _: 1
              }, 8, ["onClick"]), __props.type !== 0 && __props.userRole.isSupplier && canEdit(proofDialog.currentRow) ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                link: "",
                type: "danger",
                size: "small",
                onClick: $event => handleDeleteProof(scope.row)
              }, {
                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [_createTextVNode(" 删除 ", -1)]))]),
                _: 1
              }, 8, ["onClick"])) : _createCommentVNode("", true)])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"]))]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(MoreUpload, {
          visible: uploadProofDialog.visible,
          "onUpdate:visible": _cache[15] || (_cache[15] = $event => uploadProofDialog.visible = $event),
          title: "上传证明材料",
          multiple: true,
          onUploadSuccess: handleUploadSuccess
        }, null, 8, ["visible"]), _createVNode(_component_el_dialog, {
          modelValue: proofTemplateMonthDialog.visible,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => proofTemplateMonthDialog.visible = $event),
          title: "计提证明材料模板",
          width: "700px",
          "append-to-body": "",
          onClose: closeMonthProofTemplateDialog
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_30, [_createVNode(_component_el_button, {
            onClick: closeMonthProofTemplateDialog
          }, {
            default: _withCtx(() => [...(_cache[62] || (_cache[62] = [_createTextVNode("关闭", -1)]))]),
            _: 1
          })])]),
          default: _withCtx(() => [__props.userRole.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[16] || (_cache[16] = $event => proofTemplateMonthDialog.uploadVisible = true)
          }, {
            default: _withCtx(() => [...(_cache[59] || (_cache[59] = [_createTextVNode("上传文件", -1)]))]),
            _: 1
          })])) : _createCommentVNode("", true), _createVNode(_component_el_table, {
            data: proofTemplateMonthDialog.fileList,
            border: "",
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "fileName",
              label: "文件名",
              "min-width": "360"
            }), _createVNode(_component_el_table_column, {
              label: "操作",
              width: "200"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: $event => handlePreviewMonthProofTemplate(scope.row)
              }, {
                default: _withCtx(() => [...(_cache[60] || (_cache[60] = [_createTextVNode("预览", -1)]))]),
                _: 1
              }, 8, ["onClick"]), __props.userRole.isAdmin ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                link: "",
                type: "danger",
                size: "small",
                onClick: $event => handleDeleteMonthProofTemplate(scope.row)
              }, {
                default: _withCtx(() => [...(_cache[61] || (_cache[61] = [_createTextVNode(" 删除 ", -1)]))]),
                _: 1
              }, 8, ["onClick"])) : _createCommentVNode("", true)])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(MoreUpload, {
          visible: proofTemplateMonthDialog.uploadVisible,
          "onUpdate:visible": _cache[18] || (_cache[18] = $event => proofTemplateMonthDialog.uploadVisible = $event),
          title: "上传计提证明材料模板",
          multiple: true,
          onUploadSuccess: handleUploadMonthProofTemplateSuccess
        }, null, 8, ["visible"]), contextMenu.visible ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "context-menu",
          style: _normalizeStyle({
            left: contextMenu.x + 'px',
            top: contextMenu.y + 'px'
          }),
          onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("div", {
          class: "context-menu-item",
          onClick: openReasonDialog
        }, "原因说明")], 4)) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
          modelValue: reasonDialog.visible,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => reasonDialog.visible = $event),
          title: "原因说明",
          width: "500px",
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_31, [_createVNode(_component_el_button, {
            onClick: _cache[21] || (_cache[21] = $event => reasonDialog.visible = false)
          }, {
            default: _withCtx(() => [...(_cache[63] || (_cache[63] = [_createTextVNode("取消", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: saveReason
          }, {
            default: _withCtx(() => [...(_cache[64] || (_cache[64] = [_createTextVNode("确定", -1)]))]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            model: reasonDialog,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "原因说明"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: reasonDialog.remark,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => reasonDialog.remark = $event),
                type: "textarea",
                rows: 4,
                placeholder: "请输入原因说明",
                maxlength: "500",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: vendorImportDialog.visible,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => vendorImportDialog.visible = $event),
          title: "导入填写",
          width: "500px",
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [_createElementVNode("span", _hoisted_32, [_createVNode(_component_el_button, {
            onClick: closeVendorImportDialog
          }, {
            default: _withCtx(() => [...(_cache[67] || (_cache[67] = [_createTextVNode("取消", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleVendorImportConfirm,
            loading: vendorImportDialog.uploading
          }, {
            default: _withCtx(() => [...(_cache[68] || (_cache[68] = [_createTextVNode("确定", -1)]))]),
            _: 1
          }, 8, ["loading"])])]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-width": "100px"
          }, {
            default: _withCtx(() => [__props.month ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "计提月份"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(__props.month), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
              label: "选择文件",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_upload, {
                "file-list": vendorImportDialog.fileList,
                "auto-upload": false,
                limit: 1,
                "on-change": handleVendorImportFileChange,
                "on-remove": handleVendorImportFileRemove
              }, {
                tip: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createElementVNode("div", {
                  class: "el-upload__tip"
                }, "请选择 Excel 文件", -1)]))]),
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary"
                }, {
                  default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode("选取文件", -1)]))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["file-list"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};